import { MagnifyingGlassIcon } from "@radix-ui/react-icons"
import { Box, Container, Flex, RadioGroup, Select, Text, TextField } from "@radix-ui/themes"

export interface FilterTransactionsFormProps {
    search?: boolean,
    min?: boolean,
    max?: boolean,
    typeTransaction?: boolean,
    currency?: boolean,
    sortDate?: boolean
}



export default function FilterTransactionsForm(props: FilterTransactionsFormProps) {
    const {search, min, max, typeTransaction, currency, sortDate} = props
    return (
          <Box className="block-filters p-5">
            <Container className="mb-5"> 
            { search &&
            <TextField.Root name="search" placeholder="Поиск по ID, ID кассы">
              <TextField.Slot>
                                    <MagnifyingGlassIcon />
                                </TextField.Slot>
            </TextField.Root>
            }
            </Container>
                    <Flex className="pb-3" gap={'3'} wrap={'wrap'}>
                        { min &&
                        <Box> 
                        <Text>Мин цена</Text>
                        <TextField.Root name="minAmount" placeholder="Цена, от" type="number">

                        </TextField.Root>
                        </Box>
                        }

                        {max &&
                        <Box> 

                        <Text>Макс цена</Text>
                        <TextField.Root name="maxAmount" placeholder="Цена, до" type="number">

                        </TextField.Root>
                        </Box>
                        }
                        { typeTransaction &&
                        <Flex direction={'column'}>
                        <Text>Тип транзакции</Text>
                        <Select.Root name="typeTransaction" defaultValue="empty">
		<Select.Trigger/>
		<Select.Content>
            <Select.Item value="empty">Без выбора</Select.Item>
			<Select.Item value="Внутренний перевод валюты">Внутренний перевод валюты</Select.Item>
            <Select.Item value="Вывод средств">Вывод средств</Select.Item>
            <Select.Item value="Распределение средств в Минфин">Распределение средств в Минфин</Select.Item>
		</Select.Content>
	</Select.Root>
    </Flex>
}

    { currency &&
    <Flex direction={'column'}>
         <Text>Валюта</Text>
        <Select.Root defaultValue="empty" name="currency">
		<Select.Trigger />
		<Select.Content>
            <Select.Item value="empty">Без выбора</Select.Item>
			<Select.Item value="Рубль">Рубль</Select.Item>
            <Select.Item value="Рассвет">Рассвет</Select.Item>
		</Select.Content>
	</Select.Root>
    </Flex>
    }
                    { sortDate &&
                   <Flex direction={'column'}>
                        <Text>Сортировать по дате</Text>
                        <RadioGroup.Root name="dateSort" defaultValue="DESC">
	                    <RadioGroup.Item value="DESC">По убыванию</RadioGroup.Item>
	                    <RadioGroup.Item value="ASC">По возрастанию</RadioGroup.Item>
                        </RadioGroup.Root>
                   </Flex>
                    }
                    </Flex>
                </Box>
    )
}